import { useMutation } from "@tanstack/react-query";

interface SaveArtifactPayload {
  title: string;
  type: string;
  spec_json?: unknown;
  sql_query?: string;
}

export function useSaveArtifact() {
  return useMutation({
    mutationFn: async (payload: SaveArtifactPayload) => {
      const resp = await fetch("/api/artifacts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!resp.ok) throw new Error("Failed to save artifact");
      return resp.json();
    },
  });
}
